export default "__VITE_ASSET__BpWtYhIo__"